import { call, put, takeLatest } from "redux-saga/effects";
import { ActionWithPayload } from "@shared/interfaces";
import { startLoading, stopLoading } from "@shared/store/actions";

import { ProcedureIndexStatusFilter, ProcedureIndexStatusResponse } from "../interfaces";
import { getProcedureIndexStatus } from "./actions";
import api from "../api";

export function* getProcedureIndexStatusSaga({ payload }: ActionWithPayload<ProcedureIndexStatusFilter>) {
  try {
    yield put(startLoading());
    const response: ProcedureIndexStatusResponse = yield call(api.getProcedureIndexStatus, payload);
    yield put(stopLoading());
    yield put(getProcedureIndexStatus.success(response));
  } catch (error) {
    yield put(getProcedureIndexStatus.failure(error as Error));
    yield put(stopLoading());
  }
}

function* procedureIndexSagas() {
  yield takeLatest(getProcedureIndexStatus.request, getProcedureIndexStatusSaga);
}

export default procedureIndexSagas;
